
/*
 * @Description: 产品公司间结算价
 * @Author: lqt
 * @Date: 2023-9-6 09:31:48
 */
<template>
  <div class="classify-manager"
       @keyup.enter="enterSearch">
    <el-form class="table-search-bar"
             inline
             :model="itemSettlePriceForm"
             ref="itemSettlePriceForm">
      <el-form-item label="接收日期"
                    prop="queryDate">
        <el-date-picker v-model="itemSettlePriceForm.queryDate"
                        type="date"
                        value-format="yyyy-MM-dd">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="商品名称"
                    prop="itemName">
        <el-input v-model="itemSettlePriceForm.itemName"
                  placeholder="请输入商品名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary"
                   @click="handleSearch"
                   icon="el-icon-search">搜索</el-button>
        <el-button type="primary"
                   @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="list"
              style="width: 100%"
              tooltip-effect="light">
      <el-table-column prop="itemName"
                       label="产品名称"
                       :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column prop="itemCode"
                       label="产品编码"
                       :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column prop="settlePrice"
                       label="公司间结算价格"
                       :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column prop="avgPrice"
                       label="公司间市场价格"
                       :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column prop="syncDate"
                       label="结算日期"
                       :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column prop="createTime"
                       label="接收时间"
                       :show-overflow-tooltip="true">
      </el-table-column>
    </el-table>
    <div>
      <el-pagination :page-sizes="[10, 20, 50, 100]"
                     :page-size="listState.pageSize"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="listState.total"
                     :current-page="listState.pageNum"
                     background
                     @current-change="handleCurrentChange"
                     @size-change="handleSizeChange">
      </el-pagination>
<!--      <div class="output-box">-->
<!--        每页<el-select class="select-page"-->
<!--                   v-model="exportForm.pageSize"-->
<!--                   placeholder="请选择条数">-->
<!--          <el-option v-for="item in sizeArr"-->
<!--                     :key="item.value"-->
<!--                     :label="item.label"-->
<!--                     :value="item.label">-->
<!--          </el-option>-->
<!--        </el-select>条-->
<!--        第<el-select class="select-page"-->
<!--                   v-model="exportForm.pageNum"-->
<!--                   placeholder="请输入页码">-->
<!--          <el-option v-for="item in sizeNumber"-->
<!--                     :key="item"-->
<!--                     :label="item"-->
<!--                     :value="item">-->
<!--          </el-option>-->
<!--        </el-select>页-->
<!--&lt;!&ndash;        <el-button class="select-page-btn"&ndash;&gt;-->
<!--&lt;!&ndash;                   type="primary"&ndash;&gt;-->
<!--&lt;!&ndash;                   @click="handleExport()">导出为CSV文件</el-button>&ndash;&gt;-->
<!--      </div>-->
    </div>
  </div>
</template>
<script>

import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'moYuanItemSettlePriceManager',
  data () {
    return {
      itemSettlePriceForm: {
        queryDate: '',
        itemName: '',
        statType: 0
      },
      sizeArr: [
        { value: 1000, label: '1000' },
        { value: 5000, label: '5000' },
        { value: 10000, label: '10000' },
        { value: 20000, label: '20000' }
      ],
      exportForm: {
        pageNum: 1,
        pageSize: 1000
      }
    }
  },
  computed: {
    ...mapGetters({
      list: 'getItemSettlePriceList',
      listState: 'getItemSettlePriceListState'
    }),
    sizeNumber () {
      const maxNo = Math.ceil(this.listState.total / this.exportForm.pageSize) + 1
      const newArr = [...new Array(maxNo).keys()]
      newArr.shift()
      return newArr
    }
  },
  mounted () {
    this.handleSearch()
  },
  methods: {
    ...mapActions(['getItemSettlePrice']),
    enterSearch (e) { // 回车搜索
      this.handleSearch()
    },
    handleSearch () {
      const params = {
        ...this.itemSettlePriceForm,
        pageNum: 1,
        pageSize: 10
      }
      this.getItemSettlePrice(params)
    },
    reset () {
      this.$refs['itemSettlePriceForm'].resetFields()
      this.handleSearch()
    },
    // 分页条数变更
    handleSizeChange (val) {
      this.getItemSettlePrice({ pageSize: val, pageNum: 1 })
    },
    // 分页跳转
    handleCurrentChange (val) {
      this.getItemSettlePrice({ pageNum: val })
    },
    handleExport () {
      if (!Array.isArray(this.list) || this.list.length === 0) {
        this.$message({
          message: '暂无数据',
          type: 'warning'
        })
        return
      }
      this.$confirm('是否确认导出', '导出', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.specialSaleQueryListExport({ ...this.itemSettlePriceForm, ...this.exportForm }).then((res) => {
          if (res.type !== 'application/json') {
            var createDownloadFile = function downloadFile () {
              let blobObject = new Blob([res])
              let fileName = '墨源公司间商品结算价.xls'
              // 兼容 IE系列 浏览器
              if (window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(blobObject, fileName)
              } else {
                let link = document.createElement('a')
                link.download = fileName
                link.style.display = 'none'
                link.target = '_Blank'
                link.href = window.URL.createObjectURL(blobObject)
                // console.log(link)
                document.body.appendChild(link)
                link.click()
                window.URL.revokeObjectURL(link.href)
              }
            }
            createDownloadFile()
            this.$message.success('导出成功')
            this.itemSettlePriceForm.pageNum = 1
            this.itemSettlePriceForm.pageSize = 20000
          } else {
            this.$message.error('操作过于频繁,请30S后再试!')
          }
        })
      })
        .catch(() => {
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.output-box {
  margin-top: 20px;
  text-align: right;
}
</style>
